import { useGetQuery } from '../../graphql';
import { GET_WORKSPACE_COMMUNICATION_SETTINGS } from './useWorkspaceEmailSettings';

export interface WorkspaceSmsSettings {
  smsEnabled: boolean | null;
}

/**
 * Reads whether the workspace texts callers back on PHONE-origin Activities
 * (plan 0026 Phase 1). MUST use the same document as
 * useWorkspaceEmailSettings / useWorkspacePhoneNumber — useGetQuery keys by
 * modelName+id, not by document, so a hook-specific selection silently loses
 * the cache race when multiple hooks mount together on the Communication page.
 */
export const useWorkspaceSmsEnabled = (workspaceId?: string) => {
  const { data, isLoading, refetch } = useGetQuery({
    modelName: 'workspace',
    query: GET_WORKSPACE_COMMUNICATION_SETTINGS,
    id: workspaceId ?? '',
    options: {
      enabled: !!workspaceId,
    },
  });

  const workspace = data as WorkspaceSmsSettings | undefined;

  return {
    smsEnabled: workspace?.smsEnabled ?? false,
    isLoading,
    refetch,
  };
};
